import { ChartNoDataIcon } from 'assets/icons';

import styled from 'styled-components';
import { Palette } from 'config';

export const ChartError = ({ message }) => {
  return (
    <ErrorWrap>
      <ChartNoDataIcon />
      <p>{message || 'No data'}</p>
    </ErrorWrap>
  );
};

export const ErrorWrap = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  line-height: 14px;
`;
